import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ParamContext } from '../../service/param.context';
import { SERVER_API_URL } from '../../../app.constants';
import { StudyInstanceModel } from '../../dataset/model/study-instance.model';
import { StudyInstanceObservation } from '../model/study-instance-observation.model';
import { StudyInstanceDescriptor } from '../model/study-instance-descriptor.model';
import { EnableLoadingIndicator, EnableSavingIndicator } from '../../loading-indicator';
import { SkipErrorInterceptor } from '../../../blocks/interceptor/error.interceptor';

@Injectable({
    providedIn: 'root',
})
export class StudyInstanceService {

    constructor(private http: HttpClient,
                private paramContext: ParamContext) {
    }

    createStudyInstances(
        studyId: number,
        numberOfInstancesToGenerate: number
    ): Observable<StudyInstanceModel[]> {
        const url = `${SERVER_API_URL}crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/studies/${studyId}/instances/generation`;
        const params = new HttpParams().set('numberOfInstancesToGenerate', numberOfInstancesToGenerate.toString());
        return this.http.post<StudyInstanceModel[]>(url, {}, { params, context: new HttpContext().set(EnableSavingIndicator, true) });
    }

    deleteStudyInstances(studyId: number, instanceIds: number[]): Observable<void> {
        const url = `${SERVER_API_URL}crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/studies/${studyId}/instances`;
        const params = new HttpParams().set('instanceIds', instanceIds.join(','));
        return this.http.delete<void>(url, { params, context: new HttpContext().set(EnableSavingIndicator, true) });
    }

    listStudyInstances(studyId: number): Observable<StudyInstanceModel[]> {
        const url = `${SERVER_API_URL}crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/studies/${studyId}/instances`;
        return this.http.get<StudyInstanceModel[]>(url, { context: new HttpContext().set(EnableLoadingIndicator, true) });
    }

    getStudyInstance(
        studyId: number,
        instanceId: number
    ): Observable<StudyInstanceModel> {
        const url = `${SERVER_API_URL}crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/studies/${studyId}/instances/${instanceId}`;
        return this.http.get<StudyInstanceModel>(url, { context: new HttpContext().set(EnableLoadingIndicator, true) });
    }

    addOrUpdateInstanceObservation(studyId: number, instanceId: number, observationDataId: number, observationData: StudyInstanceObservation
    ): Observable<StudyInstanceObservation> {
        const url = `${SERVER_API_URL}crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/studies/${studyId}/instances/${instanceId}/observations`;
        return this.http.patch<StudyInstanceObservation>(url, observationData, { context: new HttpContext().set(EnableSavingIndicator, true) });
    }

    addOrUpdateInstanceDescriptor(
        studyId: number,
        instanceId: number,
        descriptorData: StudyInstanceDescriptor
    ): Observable<StudyInstanceDescriptor> {
        const url = `${SERVER_API_URL}crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/studies/${studyId}/instances/${instanceId}/descriptors`;
        return this.http.patch<StudyInstanceDescriptor>(url, descriptorData, { context: new HttpContext().set(EnableSavingIndicator, true).set(SkipErrorInterceptor, true) });
    }

    deleteInstanceGeoreferences(
        studyId: number,
        instanceId: number
    ): Observable<void> {
        const url = `${SERVER_API_URL}crops/${this.paramContext.cropName}/programs/${this.paramContext.programUUID}/studies/${studyId}/instances/${instanceId}/georeferences`;
        return this.http.delete<void>(url, { context: new HttpContext().set(EnableSavingIndicator, true) });
    }
}
